// Search Trigger Group(2700423152)
/* Raghu 27/10/2022 2700423152 Input Field Enhancements and Font size fixes */
import React, {useEffect} from 'react';
import TriggerSearchForm from './TriggerSearchForm';
import {useDispatch} from 'react-redux';
import {resetTriggerGroupData} from '../../../../redux/reducers/TriggerGroup';
function SearchTriggerGroup({setValue, setRowSelected}) {
  const dispatch = useDispatch();

  // reset Trigger Group Data(2700423152)
  useEffect(() => {
    dispatch(resetTriggerGroupData());
  }, []);

  return (
    <div>
      <div className={`mb-0`}>
        <TriggerSearchForm setValue={setValue} setRowSelected={setRowSelected}/>
      </div>
    </div>
  );
}

export default SearchTriggerGroup;
